<template>
    <div class="body">
        <div class="contractList">
            <div class="info">
                <el-descriptions title="基础信息" :column="1">

                    <el-descriptions-item label="合同编号">{{data.num}}</el-descriptions-item>
                    <el-descriptions-item label="储存项目" >{{data.project}}</el-descriptions-item>
                    <el-descriptions-item label="合同金额" >{{data.price}}</el-descriptions-item>
                    <el-descriptions-item label="付款方式" >{{data.price_type==1?'全款':'分期'}}</el-descriptions-item>
                    <el-descriptions-item label="签订时间" >{{data.sign_time}}</el-descriptions-item>
                    <el-descriptions-item label="取样时间" >{{data.sampling_time}}</el-descriptions-item>
                    <el-descriptions-item label="入库日期" >{{data.put_time}}</el-descriptions-item>
                    <el-descriptions-item label="储存位置" >{{data.position}}</el-descriptions-item>
                    <el-descriptions-item label="储存规格" >{{data.specs}}</el-descriptions-item>
                    <el-descriptions-item label="储存期限" >{{data.end_time}}</el-descriptions-item>
                </el-descriptions>

                <el-descriptions title="服务信息" :column="1">
                    <el-descriptions-item label="储存证"><el-tag size="small" @click="pdf(data.card)">点击查看</el-tag></el-descriptions-item>
                    <el-descriptions-item label="质检报告"><el-tag size="small" @click="pdf(data.inspection_report)">点击查看</el-tag></el-descriptions-item>
                    <el-descriptions-item label="年检报告"><el-tag size="small" @click="pdf(data.inspect_annually)">点击查看</el-tag></el-descriptions-item>
                    <el-descriptions-item label="保险"><el-tag size="small" @click="pdf(data.insurance)">点击查看</el-tag></el-descriptions-item>
                    <el-descriptions-item label="发票"><el-tag size="small" @click="pdf(data.invoice)">点击查看</el-tag></el-descriptions-item>
                </el-descriptions>
            </div>
           
        </div>
    </div>
    
</template>
<script>
    import { 
        contractInfo,
    } from "@/api/api.js";
    
    export default {
        name: "contractInfo",
        data(){
            return {
                id:0,
                data:[]
            }
        },
        created(){
    
            if(this.$route.query.id == undefined || this.$route.query.id == ''){
              this.$message.error('订单号不存在');
              this.$router.push({ name: 'contractList'})
            }
            this.id = this.$route.query.id
            this.info()
        },
        methods:{
            info(){
                let data = {
                    id:this.id
                }
                contractInfo(data).then(res=>{
                    this.data = res.data
                })
            },
            pdf(file){
                // location.href=file
                window.open(file);
            },
        }
    }
    </script>
<style lang="scss" scoped>
    .body{
        background-color: #f2f2f2;
        width: 100%;
        height: 100%;
    }
    .contractList{
        text-align: left;
        background-color: #fff;
        width: 800px;
        height: 100%;
        margin: 0 auto;
        .info{
            padding: 20px;
        }
        .el-tag{
            cursor: pointer;
        }
    }
</style>